<script setup>
import { get, post, reOrder, validators } from '@/common/util'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { reactive } from 'vue'
import Draggable from 'vuedraggable'
const props=defineProps({tartbl:{type:String},ispop:{type:Boolean,default:true},usedefaultgroup:{type:Boolean,default:false}}),emit=defineEmits(['onSel','onSearch','onUpdate'])
  ,metaStore=useMetaStore(),meta=reactive({groups:[]})
,mod=async()=>{
  if(meta.groups.some(gr=>gr.nm==meta.groupnm))return metaStore.toastKey('nm_already_taken',false)
  if(meta.poptype=='add'){
    if(meta.groupnm=='기본그룹'||meta.groupnm=='Default Groups'){
      return metaStore.toast('사용할 수 없는 그룹명 입니다.',false)
    }
    meta.groups.push({nm:meta.groupnm,tartbl:props.tartbl})
  }
  if(meta.poptype=='mod')meta.groups.find(gr=>gr.selected===true).nm=meta.groupnm
  if((meta.poptype=='add'||meta.poptype=='mod')&&meta.groupnm.length>50){
    return metaStore.toast('그룹명은 50자 이상 사용할 수 없습니다.',false)
  }
  if(meta.poptype=='save')save()
  if(meta.poptype=='del'){
    meta.isloading=true
    const res=await post('rest/authed/member/listingroup',meta.groups.find(gr=>gr.selected===true))
    meta.isloading=false
    if(res.data.length>0)return metaStore.toastKey('subdata_exists',false)
    _.remove(meta.groups,gr=>gr.selected)
  }
  pop()
  if(!props.ispop)await save()
},pop=(type)=>{
  const selgroup=selectedGroup()
  if(!selgroup&&(type=='mod'||type=='del')){
    meta.poptype=null
    meta.onpop=false
    return metaStore.toastKey('sel_tar_con',false)
  }
  meta.poptype=type
  meta.groupnm=null
  meta.onpop=!(_.isEmpty(type)||type.toString().includes('Event'))
  if(!meta.onpop)return
  if(type=='add')meta.popttl='newgroups'
  if(type=='mod'){
    meta.popttl='editthegroupname'
    meta.groupnm=selgroup.nm
  }
  if(type=='del')meta.popttl='del_lbl_conttl'
  if(type=='save')meta.popttl='con_save_ttl'
},move=async(idx)=>{
  const selgroup=meta.groups.find(gr=>gr.selected===true)
  meta.lastidx=null
  if(!selgroup)return
  meta.groups=reOrder(meta.groups,selgroup,idx)
  meta.lastidx=meta.groups.indexOf(selgroup)
  if(!props.ispop)save()
},sel=async(selgroup)=>{
  meta.groups.forEach(gr=>gr.selected=false)
  if(!selgroup)return emit('onSel',null,-1)
  selgroup.selected=true
  meta.lastidx=meta.groups.indexOf(selgroup)
  emit('onSel',selgroup,meta.lastidx)
},save=async()=>{
  pop()
  meta.isloading=true
  meta.groups.forEach((group,index)=>group.gorder=index)
  const res=await post('rest/authed/admin/resetgroups',meta.groups.length?meta.groups:[{tartbl:props.tartbl,etc:'onlydelete'}])
  meta.isloading=false
  metaStore.toastRslt(res,true)
  if(res.isSuccess)await search()
  emit('onUpdate',meta.groups)
},selectedGroup=()=>{
  return meta.groups.find(group=>group.selected)
},dragChange=(changed)=>{
  if(!props.ispop)save()
},dragEnd=drag=>{
  console.log(drag)
},search=async()=>{
  meta.isloading=true
  const res=await get('rest/authed/member/groups/'+props.tartbl)
  meta.isloading=false
  meta.groups=res.data
  const lastgroup=meta.groups.find(group=>group.gorder===meta.lastidx)
  if(lastgroup)lastgroup.selected=true
  emit('onSearch',selectedGroup())
}
defineExpose({selectedGroup,search})
search()
</script>
<template>
  <v-card :flat="props.ispop" min-width="350" max-width="480" height="99%" rounded="5" class="ma-1">
    <v-card-title>
      <v-row>
        <v-col>{{ $t('managegroups') }}</v-col>
        <v-col v-if="props.ispop" cols="2" class="text-right"><v-btn size="34" variant="text" density="compact" icon="mdi-close" @click="metaStore.pop({ison:false})"/></v-col>
      </v-row>
    </v-card-title>
    <v-row class="pa-3">
      <v-col><v-btn block :text="$t('refresh')" @click="search"/></v-col>
      <v-col><v-btn block color="error" :text="$t('delete')" :disabled="!meta.groups.some(group=>group.selected)" @click="pop('del')"/></v-col>
      <v-col><v-btn block color="info" :text="$t('modify')" :disabled="!meta.groups.some(group=>group.selected)" @click="pop('mod')"/></v-col>
      <v-col><v-btn block color="warning" :text="$t('add')" @click="pop('add')"/></v-col>
      <v-col v-if="props.ispop"><v-btn block color="primary" :text="$t('save')" @click="pop('save')"/></v-col>
    </v-row>
    <v-row class="bg-grey-lighten-3 ps-4 pe-4 mgmovebtns pt-2 pb-2">
      <v-col v-for="flag in ['top_-double-up','up_-up','down_-down','bottom_-double-down']">
        <v-btn block :disabled="!meta.groups.some(group=>group.selected)" :prepend-icon="'mdi-chevron'+flag.split('_')[1]" variant="outlined" density="compact" :text="$t(flag.split('_')[0])" @click="move(flag.split('_')[0])"/>
      </v-col>
    </v-row>
    <v-card-text class="pt-5 ps-0 pe-0">
      <v-row no-gutters style="min-height: 500px;overflow-y: auto;">
        <v-col>
          <v-alert v-if="props.usedefaultgroup" block class="cursor-pointer ma-2" :color="!meta.groups.length||meta.groups.every(group=>!group.selected)?'info':''" :text="$t('defaultgroups')" @click="sel()"/>
          <Draggable v-model="meta.groups" :key="meta.groups.id" item-key="id" @end="dragEnd" @change="dragChange">
            <template #item="{element}">
              <v-alert block class="cursor-pointer ma-2" :color="element.selected?'info':''" :text="element.nm" @click="sel(element)"/>
            </template>
          </Draggable>
        </v-col>
      </v-row>
    </v-card-text>
    <v-overlay contained v-model="meta.onpop" class="align-center justify-center" :persistent="meta.poppersist">
      <v-progress-circular v-if="meta.isloading" color="primary" size="64" indeterminate/>
      <v-sheet v-else>
        <v-card v-if="meta.poptype" class="mx-auto" min-width="340" :title="$t(meta.popttl).replace('_lbl_',$t('managegroups'))">
          <v-divider/>
          <v-card-text>
            <v-text-field v-if="meta.poptype=='add'||meta.poptype=='mod'" variant="outlined" density="compact" maxlength="50" :label="$t('groupname')"
              :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]" v-model="meta.groupnm"/>
            <div v-if="meta.poptype=='del'||meta.poptype=='save'">{{ $t(meta.poptype+'_con') }}</div>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-row justify="end">
              <v-btn :text="$t('cancel')" variant="elevated" @click.stop="meta.onpop=false"/>
              <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" @click.stop="mod" :disabled="meta.poptype=='mod'?_.isEmpty(meta.groupnm):false"/>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </v-overlay>
  </v-card>
</template>
<style>
.mgmovebtns button{background-color: #fff;}
</style>
